/**
 * Forgot-password feature strings.
 *
 * Namespace: forgotPassword
 */
export const forgotPassword = {
  // Page
  page: {
    title: "Elfelejtett jelszó",
    subtitle: "Adja meg az e-mail címét a jelszó visszaállításához",
    backToLogin: "Vissza a bejelentkezéshez",
  },

  // Form fields
  form: {
    emailLabel: "E-mail cím",
    emailPlaceholder: "példa@example.com",
    submitButton: "Küldés",
    // A076: shown while the tenant picker is still open — a request without a tenant would
    // silently do nothing, so submission stays blocked until an organisation is chosen.
    tenantRequired: "Először válasszon szervezetet.",
  },

  // Errors
  errors: {
    recaptchaFailed: "reCAPTCHA ellenőrzés sikertelen. Kérjük, próbálja újra.",
  },

  // A076a: shown instead of the form when no organisation can be determined — without one the request
  // would be accepted and no email sent, so the reset is not offered at all.
  noApplicationContext: {
    title: "A szervezet nem azonosítható",
    message:
      "A jelszó visszaállítását abból az alkalmazásból kell elindítania, amelyhez a fiókja tartozik. Nyissa meg az alkalmazás bejelentkezési oldalát, majd válassza az „Elfelejtett jelszó” lehetőséget.",
  },

  // Success
  success: {
    title: "E-mail elküldve!",
    message:
      "Ha az e-mail cím szerepel a rendszerünkben, hamarosan kap egy levelet a jelszó visszaállításához.",
    backToLogin: "Vissza a bejelentkezéshez",
  },
} as const;
